import { useEffect, useState } from "react";
import {
  fetchQuickBooksReportsLastSync,
  QuickBooksLastSync,
} from "@/api/fetchQuickBooksReportsLastSync";

export const useQuickBooksLastSync = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [lastSync, setLastSync] = useState<QuickBooksLastSync>({
    lastSuccessfulSyncAt: null,
    latestReportUuid: null,
    latestReportSnapshotAt: null,
    latestReportDate: null,
  });

  useEffect(() => {
    fetchQuickBooksReportsLastSync()
      .then((response) => {
        setLastSync(response.data);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { loading, ...lastSync };
};
